import React from 'react';
import {ScrollText} from "../scrolltext/ScrollText"
import { ExpandLess, ExpandMore } from "@mui/icons-material"

import "./aitest.css"

export const Description = ({ rows, title, placeholder, disabled, description, onChange }) => {


  const [displaydescription, setDisplayDescription] = React.useState(false);
 
  const onDisplayDescription = () => {
    setDisplayDescription(!displaydescription)
  }
 
  return (
   
    <div>
     
     
      <div className="aitestactionbutton" onClick={() => { onDisplayDescription() }}>
        {
          (displaydescription) ?
            <ExpandLess className="aitestIcon" />
              :
            <ExpandMore className="aitestIcon" />
        }
       {title}
      </div>

    {
      displaydescription &&
      <ScrollText rows={rows} text={description} disabled={disabled} placeholdertext={placeholder} onChange = {onChange}/>
    }
    </div> 

  )

}

Description.defaultProps = {
  rows: 4
  }




